import { create } from 'zustand'
import type { PermissionsFeatureToggles } from 'api.gen'

type FeatureTogglesState = {
  featureToggles: PermissionsFeatureToggles
  setFeatureToggles: (toggles: PermissionsFeatureToggles) => void
}

export const useFeatureTogglesStore = create<FeatureTogglesState>()(set => ({
  featureToggles: {},
  setFeatureToggles: featureToggles => set({ featureToggles })
}))
